module.exports = __webpack_public_path__ + "img/02_3_2_1.9d75a141.png";